import React, { useState, useEffect } from 'react';
import { Alert, FormCheck, Modal, Spinner } from 'react-bootstrap';
import { HHIEButton } from '../../../utility/HHIEButton';

const servicesAndSolutions = { chr: false, dsm: false, referrals: false, notify: false };

export function AdditionalServicesModal(props) {
    const [showModal, setShowModal] = useState(false);
    const [currentServices, setCurrentServices] = useState({ ...servicesAndSolutions });
    const [checks, setChecks] = useState({ ...servicesAndSolutions });
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [resultMessage, setResultMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pendingRequestExists, setPending] = useState(false);

    useEffect(() => {
        setLoading(true);
        setPending(false);
        if (props.account.registrationType && props.account.registrationType.length !== 0) {
            var servicesStringSplit = props.account.registrationType.split(';');
            let servicesCopy = { ...servicesAndSolutions };
            for (var service of servicesStringSplit) {
                if (service === 'CHR') {
                    servicesCopy.chr = true;
                }
                else if (service === 'DSM') {
                    servicesCopy.dsm = true;
                }
                else if (service === 'Notify') {
                    servicesCopy.notify = true;
                }
                else if (service === 'Referrals') {
                    servicesCopy.referrals = true;
                }
            }
            setCurrentServices(servicesCopy);
        }
        fetch('api/registration/did-request-additional-services/' + props.account.id)
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        setLoading(false);
                        setPending(json.message);
                    })
                    .catch((ex) => {
                        console.log("Error geting a response from json", ex);
                    })
            })
            .catch((error) => {
                console.log("Error getting a response: ", error);
            });

    }, [props]);

    const submitRequest = async () => {
        setSubmitting(true);
        if // all services are currently obtained, we do nothing. Else, we submit.
            (
            // Is organization missing at least one service? (if all are true, that means org has all services. which means they don't need this modal.)
            !(currentServices.chr && currentServices.dsm && currentServices.notify && currentServices.referrals)
            &&
            // Is at least one check 'checked'?
            (checks.chr || checks.dsm || checks.notify || checks.referrals)
        ) {
            const formData = new FormData();
            formData.append("chr", checks.chr);
            formData.append("referrals", checks.referrals);
            formData.append("dsm", checks.dsm);
            formData.append("notify", checks.notify);
            formData.append("sfid", props.user.sfid);
            formData.append("account", props.account.id);

            const requestOptions = {
                method: 'POST',
                body: formData
            }
            const resultMessageCall = await fetch('api/registration/submitServicesRequest', requestOptions)
                .then(async (response) => {
                    try {
                        return await response.json()
                            .then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message
                            });
                    }
                    catch (ex) {
                        return console.log("to TEXT: submit additional services failed: ", ex);
                    }
                })
                .catch((ex) => {
                    console.log("to RESPONSE: submit additional services failed: ", ex);
                });
            setResultMessage(resultMessageCall);
            if (resultMessageCall.includes("success")) {
                setSuccess(true);
                setError(false);
                setPending(true);
            }
            else {
                setError(true);
                setSuccess(false);
                setPending(false);
            }
        }
        else {
            setSuccess(false);
            setError(true);
            setResultMessage("No action was taken. You either have all the current services, or you haven't checked any boxes.");
        }
        setSubmitting(false);
    }
    return (
        <>
            {pendingRequestExists ?
                <Alert
                    id="add-services-alert"
                    variant="info"
                    style={{
                        maxWidth: '275px'
                    }}
                >
                    The HHIE are processing a Services & Solutions Addition Request
                </Alert>
                :

                <HHIEButton
                    disabled={loading}
                    id="add-services"
                    variant="primary"
                    size="sm"
                    onClick={() => {
                        setShowModal(true);
                    }}
                    title="Request Additional Services"
                />
            }
            <Modal
                id="additional-services-modal"
                show={showModal}
                size="lg"
                centered
                onHide={() => {
                    let pvarcopy = pendingRequestExists;
                    setPending(pvarcopy);
                    setChecks({ ...servicesAndSolutions });
                    setResultMessage(null);
                    setSubmitting(false);
                    setSuccess(false);
                    setError(false);
                    setShowModal(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Request Additional Services
                    </Modal.Title>
                </Modal.Header>
                {(success || error)
                    ?
                    <Modal.Body>
                        <Alert
                            id="additional-submit-alert"
                            variant={(success) ? "success" : "warning"}>
                            {resultMessage}
                        </Alert>
                    </Modal.Body>
                    :
                    <>
                        <Modal.Body>
                            <p>
                                Select from the following services
                            </p>
                            {!currentServices.chr &&
                                <FormCheck
                                    id="chr-check"
                                    label="Community Health Record"
                                    checked={checks.chr}
                                    onChange={(e) => {
                                        let checkCopy = { ...checks };
                                        checkCopy.chr = e.target.checked;
                                        setChecks(checkCopy);
                                    }}
                                />
                            }
                            {!currentServices.dsm &&
                                <FormCheck
                                    id="dsm-check"
                                    label="Direct Secure Messaging"
                                    checked={checks.dsm}
                                    onChange={(e) => {
                                        let checkCopy = { ...checks };
                                        checkCopy.dsm = e.target.checked;
                                        setChecks(checkCopy);
                                    }}
                                />
                            }
                            {/*{!currentServices.referrals &&*/}
                            {/*    <FormCheck*/}
                            {/*        id="referrals-check"*/}
                            {/*        label="Referrals"*/}
                            {/*        checked={checks.referrals}*/}
                            {/*        onChange={(e) => {*/}
                            {/*            let checkCopy = { ...checks };*/}
                            {/*            checkCopy.referrals = e.target.checked;*/}
                            {/*            setChecks(checkCopy);*/}
                            {/*        }}*/}
                            {/*    />}*/}
                            {!currentServices.notify &&
                                <FormCheck
                                    id="notify-check"
                                    label="Notify"
                                    checked={checks.notify}
                                    onChange={(e) => {
                                        let checkCopy = { ...checks };
                                        checkCopy.notify = e.target.checked;
                                        setChecks(checkCopy);
                                    }}
                                />}
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{ textAlign: 'center', margin: 'auto' }}>
                                <HHIEButton
                                    id="additional-submit-btn"
                                    size="sm"
                                    disabled={(!checks.chr && !checks.dsm && !checks.notify && !checks.referrals)}
                                    onClick={submitRequest}
                                    title={!submitting ? "Submit Request" : <Spinner animation="border" />}
                                />
                            </div>
                        </Modal.Footer>
                    </>
                }
            </Modal>
        </>
    );
}
